import { ChevronRight } from "lucide-react";
import { useLang } from "../i18n";
import { Chapter, Reveal } from "./Reveal";

export function Process() {
  const { t } = useLang();
  return (
    <section data-testid="process-section" className="relative py-24 md:py-32 overflow-hidden">
      <div aria-hidden="true" className="absolute inset-0 overflow-hidden">
        <img src="/assets/bg-process.webp" alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#07111F]/78" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#07111F] via-transparent to-[#07111F]" />
      </div>
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <Chapter kicker={t.process.kicker} title={t.process.title} subtitle={t.process.subtitle} testId="process" />
      </div>
      <Reveal>
        <div className="no-scrollbar flex gap-0 overflow-x-auto snap-x snap-mandatory px-5 md:px-8 pb-4" data-testid="process-timeline">
          {t.process.steps.map((s, i) => (
            <div key={i} className="flex items-center snap-start shrink-0">
              <div
                data-testid={`process-step-${i + 1}`}
                className="group relative glass w-[230px] p-7 transition-[transform,border-color] duration-500 hover:-translate-y-2 hover:border-[#C9A227]/40"
                style={{ borderRadius: "4px 22px 4px 22px" }}
              >
                <span className="font-display text-5xl text-transparent" style={{ WebkitTextStroke: "1px rgba(201,162,39,0.5)" }} aria-hidden="true">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-4 font-display text-base tracking-wider text-[#F5F7FA] group-hover:text-[#C9A227] transition-colors duration-300">{s.n}</h3>
                <p className="mt-2 text-xs text-[#EDF1F6] leading-relaxed">{s.d}</p>
              </div>
              {i < t.process.steps.length - 1 && (
                <ChevronRight size={22} className="mx-2 shrink-0 text-[#C9A227]/60" aria-hidden="true" />
              )}
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
